import 'magnific-popup'
import './TweenMax.min.js'

import Swiper from 'swiper';
import { Navigation, Keyboard, A11y } from 'swiper/modules';

(($) => {

    $('html').removeClass('no-js').addClass('js');

    //Open Advent Modal
	$('.js-advent-card-trigger').magnificPopup({
		type:'inline',
		midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		mainClass: 'mfp-fade',// fades modal in
        showCloseBtn: false,
        removalDelay: 500,
        enableEscapeKey: true,
        callbacks : {
            open: function(){
                if( !$('#snow').hasClass('bring-to-front') ){
                    $('#snow').toggleClass('bring-to-front');
                }
            }
        }
        
	});
	// Close Button On Advent Modal
	$(document).on('click', '.advent-calendar-modal__close', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
        if( $('#snow').hasClass('bring-to-front') ){
            //$('#snow').toggleClass('popup-paused');
        }

	});

    const adventSwipers = document.querySelectorAll('.advent-swiper');

    adventSwipers.forEach((slider, index) => {

        let swiper = slider;
        let swiperPrev = slider.querySelector('.swiper-button-prev');
        let swiperNext = slider.querySelector('.swiper-button-next');

        const adventSwiper = new Swiper(swiper, {
            modules: [Navigation, Keyboard, A11y],
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 1000,
            loop: true,
            navigation: {
                prevEl: swiperPrev,
                nextEl: swiperNext
            },
            keyboard: {
                enabled: true
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            }
        });
    });


    // codepen resource: https://codepen.io/pinksuds/pen/VwGQepO
	function snow() {
        const isMobile = window.innerWidth < 700;
		
		let amount = isMobile ? 300 : 600;   // snowfall thickness
		let baseSize = 5;  // smallest size
		let sizeModifier = isMobile ? 10 : 15;   // size variation
		let baseDuration = isMobile ? 40 : 30;   // fall speed, increase to slow down
		let durationModifier = 40;   // fall speed variation
		let lowestOpacity = 1;  // 0 transparent, 1 opaque
	
		let container = document.getElementById('snow');
		let snowflakeTemplate = document.querySelector('.snowflake');
		
		// Clear existing snowflakes
		container.innerHTML = '';
	
		let i = 0;
		while (i < amount) {
			let flake = snowflakeTemplate.cloneNode(true);
			flake.classList.remove('snowflake');
			container.appendChild(flake);

			let size = baseSize + Math.random() * sizeModifier;
			let posX = Math.floor(Math.random() * (window.innerWidth + window.innerWidth * 0.8));
			let delay = Math.random() * -20;
			let duration = Math.random() * durationModifier + baseDuration;

			flake.style.width = size + 'px';
			flake.style.height = size + 'px';
			flake.style.left = posX + 'px';
			flake.style.animationDelay = delay + 's';
			flake.style.animationDuration = duration + 's';
			flake.style.opacity = Math.random() * (1 - lowestOpacity) + lowestOpacity;

			i++;
		}
	}
	snow();

	// Recalculate snow on window resize
	let resizeTimer;
	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			snow();
		}, 250);
	});

    //on pause button click add a pause class to the snow element
    $(document).on('click', '.btn-pause-snow', function (e) {
        e.preventDefault();
        $('#snow').toggleClass('paused');
    });

})(jQuery)